import { useState } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import TabPanel from './TabPanel';
import { setTabOnFocus, toggleRightDrawer, handleSnackBar, setFocusElement, setReRender } from '../../store/global/actions';
import { marginBottomForBreadCrumb } from '../../config/styles';
import { useDispatch, useSelector } from 'react-redux';
import BreadCrumb from '../atoms/breadcrumb/';
import Divider from '@material-ui/core/Divider';
import { Grid } from '@material-ui/core';
import SimulationEventSelector from '../molecules/simulations/SimulationEventSelector'
import { getLogRedirectionData } from '../../store/global/selectors';
import CompactAlert from '../molecules/logs/LogRedirectionAlert';

export default function SimulationEvent({ element }) {
    const dispatch = useDispatch();
    const [openTab, setOpenTab] = useState(0);
      const logRedirectionData = useSelector(getLogRedirectionData);
    const detailsBC = [
        { label: 'Simulation', url: null },
        { label: element.name, url: null }
    ];


    const onClose = () => {
        dispatch(toggleRightDrawer());
        dispatch(setFocusElement({}));
    }

    const onCompletion = (type, action) => {

        if (action != undefined) {

            switch (action) {
                case 'add':
                    dispatch(handleSnackBar({ open: true, message: `${type} created`, severity: "success" }));
                    break;

                case 'edit':
                    dispatch(handleSnackBar({ open: true, message: `${type} updated`, severity: "success" }));
                    dispatch(toggleRightDrawer());
                    dispatch(setReRender());
                    dispatch(setFocusElement({}));
                    break;

                case 'delete':
                    dispatch(handleSnackBar({ open: true, message: `${type} deleted`, severity: "success" }));
                    dispatch(toggleRightDrawer());
                    break;
                default:
                    break;

            }
        }

    }

    return (
        <>
            <AppBar position="static">
                <Tabs value={openTab} onChange={(e, v) => { dispatch(setTabOnFocus(v)); setOpenTab(v) }} aria-label="SimulationTabs">
                    <Tab label="Event" />
                </Tabs>
            </AppBar>


            <TabPanel value={openTab} index={0} >
                <Grid container direction={"row"} spacing={2}>
                    <Grid item xs={8}>
                        <BreadCrumb items={detailsBC} />
                    </Grid>
                </Grid>

                <Divider style={marginBottomForBreadCrumb} />
                {
                  (logRedirectionData?.entity === "trigger_event" && logRedirectionData.entityId === element.id) && !logRedirectionData.tabOnfocus?
                    <CompactAlert severity={logRedirectionData?.level} >{logRedirectionData?.message}</CompactAlert>
                  :
                  null
                }
                <SimulationEventSelector id={element.id} onCompletion={onCompletion} onClose={onClose} selectedSchema={element} action={'edit'} simulation_transaction_id={element.simulation_transaction_id}/>

            </TabPanel>
        </>
    )


}